import {CreateServiceMultiStepForm} from "../multi-step-form";

export function CreateServiceMultiStepFormWrapper() {
  return <CreateServiceMultiStepForm />;
}
